import { Root, TooltipProvider } from "@radix-ui/react-tooltip"


export const Tooltip = ({
    ...props
}: React.ComponentProps<typeof Root>) => {
    return (
        <TooltipProvider>
            <Root data-slot="tooltip" {...props} />
        </TooltipProvider>
    )
}